// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrap":"Loader_spinnerWrap__3u94z"};